<template>
    <div id="cesiumContainer"></div>
</template>
<script>
    import "../../../node_modules/cesium/Build/Cesium/Widgets/widgets.css";
    import turf from "turf";

    export default {
        name: "cesiumView",
        data() {
            return {
                gridLayer: "",
                drawRectangle: undefined,
                rectangleFirstPoint: undefined,
                userLayerIdList: [],
                rectangleBillboardCollection: undefined, // 添加Marker
                drawGeo: undefined,
                thumbnailArr: [], // 网格搜索
                searchPoly: undefined, // 鼠标点击产生的网格多边形
                searchPolygon: undefined,
                searchPolygonGeo: {}, // 鼠标移动产生的网格多边形
                videoDataSource: "",
                kmlTempDataSource: "",
                spectralLayer: undefined
            };
        },
        mounted() {
            this.initCesium();
        },
        methods: {
            initCesium() {
                // 初建地球仪需要添加的图层: 按照URL添加影像
                let googleImageProvider = new this.Cesium.UrlTemplateImageryProvider({
                    url: this.$store.state.servicePath.googleImageUrl,
                    style: "default", // API中未见到
                    format: "image/png", // API中未见到
                    subdomains: ["khm0", "khm1", "khm2", "khm3"], // 填充url中的{s}占位符
                    credit: "baselayer" // 显示在画布上的数据源
                });
                // 创建3D地图
                window.viewer = new this.Cesium.Viewer("cesiumContainer", {
                    // terrainProvider: this.Cesium.createWorldTerrain(),  // 提供曲面几何
                    animation: false, // 控制左下角仪表
                    baseLayerPicker: false, // 右上角地图方块，图层选择器，用于选择imagery源的
                    imageryProvider: googleImageProvider,
                    fullscreenButton: false, // 全屏按钮
                    geocoder: false, // 右上角查询按钮，搜索地址
                    homeButton: false, // 右上角小房子主页按钮
                    infoBox: false, // ——是否显示信息框
                    sceneModePicker: false, // ——是否显示3D/2D选择器
                    selectionIndicator: false, // ——是否显示选取指示器组件
                    timeline: false, // 下方时间轴
                    navigationHelpButton: false, // 右上角问号，帮助按钮
                    scene3DOnly: true, //如果设置为true，则所有几何图形以3D模式绘制以节约GPU资源
                    navigationInstructionsInitiallyVisible: false, // 右上角问号的帮助按钮，其信息是否默认显示
                    showRenderLoopErrors: false, // 是否自动弹出HTML页面的循环错误
                    shadows: true, // 模拟影子，默认false
                    requestRenderMode: true, // 渲染场景中的帧，默认为false
                    contextOptions : {
                        webgl: {
                            preserveDrawingBuffer: true    //设置canvas截图使用，不设置截屏图片黑色
                        }
                    },
                    maximumRenderTimeChange: Infinity // 渲染最大时间，默认0.0，true也是无穷大的意思
                });
                window.viewer.scene.debugShowFramesPerSecond = true;

                // this.view.scene 参数设置
                window.viewer.scene.preserveDrawingBuffer = true;
                window.viewer.scene.fxaa = false; // ——抗锯齿
                // 根据鼠标输入到画布修改camera的位置和方向。默认(1.0, 正无穷)米
                window.viewer.scene.screenSpaceCameraController.maximumZoomDistance = 20000000; // 设置相机最大高度
                window.viewer.scene.screenSpaceCameraController.minimumZoomDistance = 10; // 设置相机最小高度
                window.viewer.scene.skyAtmosphere.show = true; // 绘制环绕天空的大气，skyAtmosphere默认为undefined，且show默认值为true
                window.viewer.scene.fog.enabled = true; // 将大气与远离摄像机的几何体混合以获得水平视图，不懂有什么作用
                window.viewer.scene.globe.maximumScreenSpaceError = 1.33; // 针对地球的渲染容错率，值越高会获得更流畅体验，但是会降低显示质量
                window.viewer.scene.globe.showGroundAtmosphere = true; // 这个启用了后，下面的就都可调节了
                window.viewer.scene.globe.enableLighting = true; // 场景光源。这个启用了后，下面的就都可调节了
                window.viewer.scene.globe.lightingFadeInDistance = 30000000; // 照明恢复，默认值2kw

                this.Cesium.ScreenSpaceEventHandler.mouseEmulationIgnoreMilliseconds = 1600; // 获取到鼠标事件后禁用的时长（毫秒），默认800ms
                window.viewer._cesiumWidget._creditContainer.style.display = "none"; // ——隐藏cesium水印
                window.viewer.camera.setView({
                    // destination使用的是3维直角坐标，或者矩形。本例为3维坐标
                    destination: this.Cesium.Cartesian3.fromDegrees(116.46, 39.92, 20000000)
                }); //设置相机初始位置

                let imageryLayers = window.viewer.imageryLayers;
                window.cesiumView.googleImageLayer = imageryLayers.get(0);  // 第1种：Google地图
                window.cesiumView.googleImageLayer.show = false;
                // 以下为切换图层用的
                // 第2种：Bing地图
                let bingImageProvider = new this.Cesium.BingMapsImageryProvider({
                    url: "https://dev.virtualearth.net",
                    key: "AmI_N66xeHtfOc0GKc5JbkLdrR7AKIk9_yEhvN5954CVCbgME0qYpkQ8qgIei1Sp",
                    mapStyle: this.Cesium.BingMapsStyle.AERIAL,
                    credit: "baselayer"
                });
                window.cesiumView.bingImageLayer = imageryLayers.addImageryProvider(bingImageProvider);
                window.cesiumView.bingImageLayer.show = false;
                // 第3种：天地Vector图——地图
                let tdtVectorProvider = new this.Cesium.UrlTemplateImageryProvider({
                    url: this.$store.state.servicePath.tdtVecUrl,
                    style: "default", // API中未见到
                    format: "image/png", // API中未见到
                    subdomains: ['0', '2', '3'], // 填充url中的{s}占位符
                    credit: "baselayer" // 显示在画布上的数据源
                });
                window.cesiumView.tdtVectorLayer = imageryLayers.addImageryProvider(tdtVectorProvider);
                window.cesiumView.tdtVectorLayer.show = false;
                // 第3种：天地Vector图——标志
                let tdtBzVectorProvider = new this.Cesium.UrlTemplateImageryProvider({
                    url: this.$store.state.servicePath.tdtVecBzUrl,
                    style: "default", // API中未见到
                    format: "image/png", // API中未见到
                    subdomains: ['0', '2', '3'], // 填充url中的{s}占位符
                    credit: "baselayer" // 显示在画布上的数据源
                });
                window.cesiumView.tdtBzVectorLayer = imageryLayers.addImageryProvider(tdtBzVectorProvider);
                imageryLayers.raiseToTop(window.cesiumView.tdtBzVectorLayer);
                window.cesiumView.tdtBzVectorLayer.show = false;
                // 第4种：天地图像图——地图
                let tdtImageProvider = new this.Cesium.UrlTemplateImageryProvider({
                    url: this.$store.state.servicePath.tdtImgUrl,
                    style: "default", // API中未见到
                    format: "image/png", // API中未见到
                    subdomains: ['0', '2', '3'], // 填充url中的{s}占位符
                    credit: "baselayer" // 显示在画布上的数据源
                });
                window.cesiumView.tdtImageLayer = imageryLayers.addImageryProvider(tdtImageProvider);
                window.cesiumView.tdtImageLayer.show = true;
                // 第4种：天地图像图——标志
                let tdtBzImageProvider = new this.Cesium.UrlTemplateImageryProvider({
                    url: this.$store.state.servicePath.tdtImgBzUrl,
                    style: "default", // API中未见到
                    format: "image/png", // API中未见到
                    subdomains: ['0', '2', '3'], // 填充url中的{s}占位符
                    credit: "baselayer" // 显示在画布上的数据源
                });
                window.cesiumView.tdtBzImageLayer = imageryLayers.addImageryProvider(tdtBzImageProvider);
                imageryLayers.raiseToTop(window.cesiumView.tdtBzImageLayer);

                // 添加Marker收集器
                this.rectangleBillboardCollection = window.viewer.scene.primitives.add(
                    new this.Cesium.BillboardCollection()
                );
                // 初始化DataSource
                window.cesiumView.drawDataSource = new this.Cesium.CustomDataSource(
                    "draw"
                ); // 绘图用的
                window.viewer.dataSources.add(window.cesiumView.drawDataSource);
                window.viewer.dataSources.add(new this.Cesium.CustomDataSource("userMarker"));
                this.videoDataSource = new this.Cesium.CustomDataSource("video");
                window.viewer.dataSources.add(this.videoDataSource);
                this.kmlTempDataSource = new this.Cesium.CustomDataSource("kml");
                window.viewer.dataSources.add(this.kmlTempDataSource);

                let that = this;
                window.viewer.scene.postRender.addEventListener(function() {
                    that.$store.state.compassAngleNum = -that.Cesium.Math.toDegrees(
                        window.viewer.scene.camera.heading
                    );
                });
                window.cesiumView.tooltip = document.getElementsByClassName("tooltip-right")[0];

                this.initMouseHandlers();
            },
            initMouseHandlers() {
                let that = this;
                let handler = window.viewer.cesiumWidget.screenSpaceEventHandler;
                // 左键
                handler.setInputAction(movement => {
                    this.leftClick(movement.position); // movement是2D的
                }, this.Cesium.ScreenSpaceEventType.LEFT_CLICK);
                // 左键双击
                handler.setInputAction(movement => {
                    if (!window.viewer.scene.globe.depthTestAgainstTerrain){
                        let cartesianLatLng = window.viewer.camera.pickEllipsoid(
                            movement.position, window.viewer.scene.globe.ellipsoid
                        );
                        that.leftDoubleClick(cartesianLatLng);
                    }
                }, this.Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
                // 鼠标移动
                handler.setInputAction(movement => {
                    that.mouseMove(movement.endPosition);
                }, this.Cesium.ScreenSpaceEventType.MOUSE_MOVE);
                // 鼠标中间滚动
                handler.setInputAction(() => {
                    that.$store.state.level = that.utils.getCameraLevel(
                        Math.ceil(window.viewer.camera.positionCartographic.height)
                    );
                }, this.Cesium.ScreenSpaceEventType.WHEEL);
                // 鼠标中键按下
                handler.setInputAction(movement => {
                    that.$store.state.wheelPos = window.viewer.camera.pickEllipsoid(
                        movement.position, window.viewer.scene.globe.ellipsoid
                    );
                }, this.Cesium.ScreenSpaceEventType.MIDDLE_DOWN);
            },
            leftClick(position) {
                // 作用一：处理广告牌
                let pickedObject = window.viewer.scene.pick(position); // 这个是取广告牌之类的
                if (pickedObject !== undefined && pickedObject.id !== undefined && pickedObject.id.name === "deleteButton") {
                    // 专门针对双击生成的删除button的判断
                    window.cesiumView.drawPolylinePath = [];
                    window.cesiumView.drawPolygonPath = [];
                    let ids = window.cesiumView.curMeasureIds;
                    window.cesiumView.curMeasureIds = [];
                    this.$store.state.isMeasuring = false;
                    for (let i = 0; i < ids.length; i++) {
                        window.cesiumView.drawDataSource.entities.removeById(ids[i]);
                    }
                    return;
                }
                // 作用二: 处理点击的点
                // 仅仅是改成IDE不报红线了，还需要Chrome来debug
                let cartesianLatLng;
                // 为true时，标绘在地上部分可以显示出来；为false时，标绘都能显示出来
                if (window.viewer.scene.globe.depthTestAgainstTerrain) {
                    cartesianLatLng = window.viewer.scene.pickPosition(position);
                } else {
                    // 由直角2D像素坐标系转换为直角3D公里地理坐标系
                    cartesianLatLng = window.viewer.camera.pickEllipsoid(position, window.viewer.scene.globe.ellipsoid);
                }
                if (cartesianLatLng) {
                    //控制自定义绘制的逻辑, 只测了else的
                    if (this.gridLayer.show === true) {
                        for (let i = 0; i < this.thumbnailArr.length; i++) {
                            this.thumbnailArr[i].remove();
                        }
                        this.thumbnailArr = [];
                        this.searchPolygon = undefined;
                        let latlngArr = this.cartesianToLatLng(cartesianLatLng);
                        let polySearchGeo = this.createPolySearch(latlngArr[0].toString(), latlngArr[1].toString()); // 创建多边形
                        this.locatePoi(latlngArr[0].toString(), latlngArr[1].toString(), 150000);
                        if (typeof vm.dateRange[0] == "object") {
                            let day1 = new Date();
                            day1.setTime(vm.dateRange[0].getTime());
                            let d1 = day1.getFullYear() + "-" + (day1.getMonth() + 1) + "-" + day1.getDate();
                            let day2 = new Date();
                            day2.setTime(vm.dateRange[1].getTime());
                            let d2 = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate();
                        }
                        vm.searchGeo = polySearchGeo;
                        $("#dataLab-nav-search").trigger("click");
                    } else {
                        switch (window.cesiumView.drawOperatorFlag) {
                            case "MeasureDistance":
                                window.cesiumView.drawPolylinePath.push(cartesianLatLng);
                                let dis = "起点";
                                if (window.cesiumView.drawPolylinePath.length > 1) {
                                    dis = this.computeDis(window.cesiumView.drawPolylinePath) + "公里";
                                }
                                let bl = new this.Cesium.Entity({
                                    position: cartesianLatLng,
                                    billboard: {
                                        heightReference: this.Cesium.HeightReference.CLAMP_TO_GROUND,
                                        disableDepthTestDistance: 100000000000000000000,
                                        image: "assets/dragIcon.png"
                                    },
                                    label: {
                                        showBackground: true,
                                        heightReference: this.Cesium.HeightReference.CLAMP_TO_GROUND,
                                        font: "13px sans-serif",
                                        horizontalOrigin: this.Cesium.HorizontalOrigin.LEFT,
                                        text: dis,
                                        disableDepthTestDistance: 100000000000000000000,
                                        pixelOffset: new this.Cesium.Cartesian2(10, 10)
                                    }
                                });
                                window.cesiumView.curMeasureIds.push(bl.id);
                                window.cesiumView.drawDataSource.entities.add(bl);
                                break;
                            case "MeasureArea":
                                let bm = new this.Cesium.Entity({
                                    position: cartesianLatLng,
                                    billboard: {
                                        heightReference: this.Cesium.HeightReference.CLAMP_TO_GROUND,
                                        disableDepthTestDistance: 100000000000000000000,
                                        image: "assets/dragIcon.png"
                                    }
                                });
                                window.cesiumView.drawPolygonPath.push(cartesianLatLng);
                                window.cesiumView.curMeasureIds.push(bm.id);
                                window.cesiumView.drawDataSource.entities.add(bm);
                                break;
                            default:
                                break;
                        }
                    }
                    window.viewer.scene.requestRender();
                }
            },
            leftDoubleClick(cartesianLatLng) {
                //控制自定义绘制的逻辑
                switch (window.cesiumView.drawOperatorFlag) {
                    case "MeasureDistance":
                        let lastPoint = window.cesiumView.drawPolylinePath[window.cesiumView.drawPolylinePath.length - 1];
                        let btn = window.cesiumView.drawDataSource.entities.add({
                            name: "deleteButton",
                            position: lastPoint,
                            label: {
                                showBackground: true,
                                heightReference: this.Cesium.HeightReference.CLAMP_TO_GROUND,
                                font: "16px sans-serif",
                                horizontalOrigin: this.Cesium.HorizontalOrigin.RIGHT,
                                text: "x",
                                disableDepthTestDistance: 100000000000000000000,
                                pixelOffset: new this.Cesium.Cartesian2(-10, -10)
                            },
                        });
                        window.cesiumView.drawOperatorFlag = "";          // 设置绘画模式
                        window.cesiumView.drawPolyline = undefined;       // 清空最后一点信息
                        window.cesiumView.curMeasureIds.push(btn.id);     // 添加删除点的ID
                        window.cesiumView.tooltip.style.display = "none";
                        break;
                    case "MeasureArea":
                        if (window.cesiumView.drawPolygonPath.length > 2) {
                            // 先行添加面积数据
                            let area = this.calcPolygonArea(window.cesiumView.drawPolygonPath);
                            let bm = new this.Cesium.Entity({
                                position: cartesianLatLng,
                                label: {
                                    showBackground: true,
                                    heightReference: this.Cesium.HeightReference.CLAMP_TO_GROUND,
                                    font: "13px sans-serif",
                                    horizontalOrigin: this.Cesium.HorizontalOrigin.LEFT,
                                    text: (area/1000000).toFixed(2).toString() + "平方公里",
                                    disableDepthTestDistance: 100000000000000000000,
                                    pixelOffset: new this.Cesium.Cartesian2(10, 10)
                                },
                                show: true
                            });
                            window.cesiumView.curMeasureIds.push(bm.id);
                            window.cesiumView.drawDataSource.entities.add(bm);
                        }
                        // 然后添加删除按钮
                        let lastPointm = window.cesiumView.drawPolygonPath[window.cesiumView.drawPolygonPath.length - 1];
                        let btm = window.cesiumView.drawDataSource.entities.add({
                            name: "deleteButton",
                            position: lastPointm,
                            label: {
                                showBackground: true,
                                heightReference: this.Cesium.HeightReference.CLAMP_TO_GROUND,
                                font: "16px sans-serif",
                                horizontalOrigin: this.Cesium.HorizontalOrigin.RIGHT,
                                text: "x",
                                disableDepthTestDistance: 100000000000000000000,
                                pixelOffset: new this.Cesium.Cartesian2(-10, -10)
                            },
                        });
                        window.cesiumView.drawOperatorFlag = "";          // 设置绘画模式
                        window.cesiumView.drawPolygon = undefined;
                        window.cesiumView.curMeasureIds.push(btm.id);
                        window.cesiumView.tooltip.style.display = "none";
                        break;
                    default:
                        break;
                }
                window.viewer.scene.requestRender();
            },
            mouseMove(endPosition) {
                let cartesianLatLng;
                if (window.viewer.scene.globe.depthTestAgainstTerrain) {
                    cartesianLatLng = window.viewer.scene.pickPosition(endPosition);
                } else {
                    cartesianLatLng = window.viewer.camera.pickEllipsoid(
                        endPosition, window.viewer.scene.globe.ellipsoid
                    ); // 鼠标移动到球体上时可以返回非undefined，参数2为球体转换器，结果以弧度为单位，例如2PI
                }
                if (cartesianLatLng) {
                    // 当鼠标移动到球体表面时就会有数据，地理3D直角坐标系
                    this.degreeToString(cartesianLatLng);  // 这3个数算完之后mouseMove()内再无使用
                    switch (window.cesiumView.drawOperatorFlag) {
                        case "MeasureDistance":
                            if (window.cesiumView.drawPolylinePath.length === 0) {
                                this.showAt(endPosition, "<p >单击确定起点</p>");
                            } else {
                                this.showAt(endPosition, "<p >单击确定点,双击结束绘制</p>");
                            }
                            if (window.cesiumView.drawPolylinePath.length === 0) {
                                return;
                            }
                            if (!this.Cesium.defined(window.cesiumView.drawPolyline)) {
                                window.cesiumView.drawPolylinePath.push(cartesianLatLng);
                                window.cesiumView.drawPolyline = this.createPolyline(window.cesiumView.drawDataSource, window.cesiumView.drawPolylinePath);
                                window.cesiumView.curMeasureIds.push(window.cesiumView.drawPolyline.id);
                            } else {
                                let dis = this.computeDis(window.cesiumView.drawPolylinePath) + "公里";
                                this.showAt(endPosition, dis + "<p>单击确定点,双击结束绘制</p>");
                                window.cesiumView.drawPolylinePath.pop();
                                window.cesiumView.drawPolylinePath.push(cartesianLatLng);
                            }
                            break;
                        case "MeasureArea":
                            if (window.cesiumView.drawPolygonPath.length === 0) {
                                this.showAt(endPosition, "<p >单击确定起点</p>");
                            } else {
                                this.showAt(endPosition, "<p >单击确定点,双击结束绘制</p>");
                            }
                            if (window.cesiumView.drawPolygonPath.length < 2) {
                                return;
                            }
                            if (!this.Cesium.defined(window.cesiumView.drawPolygon)) {
                                window.cesiumView.drawPolygonPath.push(cartesianLatLng);
                                window.cesiumView.drawPolygon = this.createPolygon(window.cesiumView.drawDataSource, window.cesiumView.drawPolygonPath);
                                window.cesiumView.curMeasureIds.push(window.cesiumView.drawPolygon);
                            } else {
                                window.cesiumView.drawPolygonPath.pop();
                                window.cesiumView.drawPolygonPath.push(cartesianLatLng);
                            }
                            break;
                        default:
                            break;
                    }

                    window.viewer.scene.requestRender();
                } else {
                    let temp = document.getElementById("mainArea-globe-info-camera");
                    if (temp !== null) {
                        temp.style.display = "none";
                    }
                    temp = document.getElementById("mainArea-globe-info-lat");
                    if (temp !== null) {
                        temp.style.display = "none";
                    }
                    temp = document.getElementById("mainArea-globe-info-lon");
                    if (temp !== null) {
                        temp.style.display = "none";
                    }
                    window.cesiumView.tooltip.style.display = "none";
                }
            },
            //创建多边形
            createPolySearch(lng, lat) {
                if (this.searchPoly === undefined) {
                    this.gridLayer.show = true;
                }
                let pos = this.Cesium.Cartesian3.fromDegrees(lng, lat);
                window.cesiumView.drawDataSource.entities.removeAll();
                this.rectangleBillboardCollection.removeAll();
                this.addMarker(
                    pos,
                    "./img/cesiumImg/gridMarker.png",
                    true,
                    this.rectangleBillboardCollection,
                    new this.Cesium.Cartesian2(0.0, -10.0)
                );
                let bounds = this.calPolySearchBounds(lng, lat, 10);
                let polyGeo = this.createGeoByBounds(bounds);
                this.searchPoly = this.loadPolyGeo(polyGeo.coordinates);
                return polyGeo;
            },
            cartesianToLatLng(cartesian) {
                let cartographic = this.Cesium.Ellipsoid.WGS84.cartesianToCartographic(
                    cartesian
                );
                let lat = this.Cesium.Math.toDegrees(cartographic.latitude);
                let lng = this.Cesium.Math.toDegrees(cartographic.longitude);
                return [lng, lat];
            },
            calPolySearchBounds(lng, lat, zoom) {
                let tempX = Math.floor(((lng + 180) / 360) * Math.pow(2, zoom));
                let tempY = Math.floor(
                    ((1 -
                        Math.log(
                            Math.tan((lat * Math.PI) / 180) +
                            1 / Math.cos((lat * Math.PI) / 180)
                        ) /
                        Math.PI) /
                        2) *
                    Math.pow(2, zoom)
                );
                let bounds = this.getLatLngBoundsFromTile(zoom, tempX, tempY);
                return [
                    bounds[0], bounds[1], bounds[0], bounds[3], bounds[2],
                    bounds[3], bounds[2], bounds[1], bounds[0], bounds[1]
                ];
            },
            getLatLngBoundsFromTile(zoom, x, y) {
                var longitudeMin = (x / Math.pow(2, zoom)) * 360 - 180;
                var longitudeMax = ((x + 1) / Math.pow(2, zoom)) * 360 - 180;
                var latitudeMin = this.tile2lat(y + 1, zoom);
                var latitudeMax = this.tile2lat(y, zoom);
                return [longitudeMax + 180, latitudeMax, longitudeMin + 180, latitudeMin];
            },
            tile2lat(y, zoom) {
                var n = Math.PI - (2.0 * Math.PI * y) / Math.pow(2, zoom);
                return (180 / Math.PI) * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n)));
            },
            // 生成多边形Geo
            createGeoByBounds(boundsArray) {
                let geoCoordinates = [];
                for (let i = 0; i < 5; i++) {
                    geoCoordinates.push([boundsArray[2 * i], boundsArray[2 * i + 1]]);
                }
                let tempGeo = [];
                tempGeo.push(geoCoordinates);
                let geoJson = {
                    type: "Polygon",
                    coordinates: tempGeo
                };
                return geoJson;
            },
            loadPolyGeo(coord) {
                let coordinates = coord;
                let posArr = [];
                for (let i = 0; i < coordinates[0].length; i++) {
                    posArr.push(coordinates[0][i][0]);
                    posArr.push(coordinates[0][i][1]);
                }
                let poly = window.cesiumView.drawDataSource.entities.add({
                    polygon: {
                        hierarchy: this.Cesium.Cartesian3.fromDegreesArray(posArr),
                        height: 0,
                        show: true,
                        followSurface: true,
                        material: this.Cesium.Color.fromRgba(0xb8e986).withAlpha(0.13),
                        outline: true,
                        outlineColor: this.Cesium.Color.fromRgba(0x62b209).withAlpha(0.86),
                        outlineWidth: 1.0
                    }
                });
                return poly;
            },
            addMarker(pos, iconUrl, bool, dataSource, pixelOffset) {
                let marker = dataSource.add({
                    show: bool,
                    position: pos,
                    pixelOffset: pixelOffset,
                    eyeOffset: new this.Cesium.Cartesian3(0.0, 0.0, 0.0),
                    horizontalOrigin: this.Cesium.HorizontalOrigin.CENTER,
                    verticalOrigin: this.Cesium.VerticalOrigin.CENTER,
                    scale: 1.0,
                    image: iconUrl,
                    color: new this.Cesium.Color(1.0, 1.0, 1.0, 1.0)
                });
            },
            // 工具方法（可以放到一个工具类里面）
            computeDis(pArray) {
                let result = 0;
                for (let i = 0; i < pArray.length - 1; i++) {
                    result += this.Cesium.Cartesian3.distance(pArray[i], pArray[i + 1]);
                }
                return (result / 1000).toFixed(2).toString();
            },
            calcPolygonArea(entity) {
                // 计算polygon面积
                let geo = {
                    type: "Polygon",
                    coordinates: [[]]
                };
                for (let i = 0; i < entity.length - 1; i++) {
                    let cartographic = this.Cesium.Cartographic.fromCartesian(entity[i]);
                    let lon = this.Cesium.Math.toDegrees(cartographic.longitude);
                    let lat = this.Cesium.Math.toDegrees(cartographic.latitude);
                    geo.coordinates[0].push([lon, lat]);
                }
                let coor1 = geo.coordinates[0][0];
                geo.coordinates[0].push([coor1[0], coor1[1]]);
                let area = turf.area(geo);
                return area;
            },
            degreeToString(cartesianLatLng) {
                // 控制右下角经纬度展示的逻辑
                document.getElementById("mainArea-globe-info-camera").style.display = "block";
                document.getElementById("mainArea-globe-info-lat").style.display = "block";
                document.getElementById("mainArea-globe-info-lon").style.display = "block";
                let cartographic = this.Cesium.Cartographic.fromCartesian(cartesianLatLng); // 转换成经纬度
                let longitudeString = this.Cesium.Math.toDegrees(cartographic.longitude).toFixed(4); // 弧度转为360°下的
                let latitudeString = this.Cesium.Math.toDegrees(cartographic.latitude).toFixed(4);
                let heightString = Math.ceil(window.viewer.camera.positionCartographic.height); // 这里使用摄像头高度而非地理高度
                let longitudeDirection, latitudeDirection; // 根据参数1&2来判断方向，并暂时存储为['W', 'E', 'S', 'N']
                if (longitudeString < 0) {
                    longitudeString = -longitudeString;
                    longitudeDirection = "W";
                } else {
                    longitudeDirection = "E";
                }

                if (latitudeString < 0) {
                    latitudeString = -latitudeString;
                    latitudeDirection = "S";
                } else {
                    latitudeDirection = "N";
                }

                let longitudeDeg = parseInt(longitudeString); // 经度的第1位数
                let longitudeTemp = (longitudeString - longitudeDeg) * 60;
                let longitudeMum = Math.floor(longitudeTemp); // 经度的第2位数
                let longitudeSec = ((longitudeTemp - longitudeMum) * 60).toFixed(0); // 经度的第3位数

                let latitudeDeg = parseInt(latitudeString);
                let latitudeTemp = (latitudeString - latitudeDeg) * 60;
                let latitudeMum = Math.floor(latitudeTemp);
                let latitudeSec = ((latitudeTemp - latitudeMum) * 60).toFixed(0);

                let heightStringLength = heightString.toString().length;

                let longitudeStr = longitudeDeg + "\u00B0" + longitudeMum + "\u2032" + longitudeSec + "\u2033" + longitudeDirection;
                let latitudeStr = latitudeDeg + "\u00B0" + latitudeMum + "\u2032" + latitudeSec + "\u2033" + latitudeDirection;
                let heightStr = this.toThousands(heightString / 1000) + "." + heightString.toString().substr(heightStringLength - 3, 2) + " km";

                document.getElementById("longitudeStr").innerHTML = longitudeStr; // 写在右下角经纬度坐标的<span>中
                document.getElementById("latitudeStr").innerHTML = latitudeStr;
                document.getElementById("heightStr").innerHTML = heightStr;
            },
            //相机相关
            locatePoi(lng, lat, height) {
                let that = this;
                window.viewer.camera.flyTo({
                    destination: that.Cesium.Cartesian3.fromDegrees(lng, lat, height),
                    complete: function() {
                        that.$store.state.level = that.utils.getCameraLevel(
                            Math.ceil(window.viewer.camera.positionCartographic.height)
                        );
                    }
                });
            },
            // 只是为了写出带逗号的写法
            toThousands(num) {
                let result = "",
                    counter = 0;
                num = (num || 0).toString();
                for (let i = num.length - 1; i >= 0; i--) {
                    counter++;
                    result = num.charAt(i) + result;
                    if (!(counter % 3) && i != 0) {
                        result = "," + result;
                    }
                }
                return result;
            },
            showAt(positions, message) {
                // 已测
                if (positions && message) {
                    window.cesiumView.tooltip.style.display = "block";
                    window.cesiumView.tooltip.lastChild.innerHTML = message;
                    window.cesiumView.tooltip.style.left = positions.x + 15 + "px";
                    window.cesiumView.tooltip.style.top = positions.y - 15 + "px";
                }
            },
            createPolyline(markerDataSource, positions, color) {
                let that = this;
                if (!this.Cesium.defined(color)) {
                    color = this.Cesium.Color.WHITE;
                }
                if (!this.Cesium.defined(positions)) {
                    throw new this.Cesium.DeveloperError("positions is required!");
                }
                if (positions.length < 2) {
                    throw new this.Cesium.DeveloperError("positions 的长度必须大于等于2");
                }
                // 准备参数
                let options = {
                    polyline: {
                        show: true,
                        clampToGround: true,
                        width: 3,
                        positions: new this.Cesium.CallbackProperty(function () {
                            return positions;
                        }, false),
                        material: new this.Cesium.PolylineOutlineMaterialProperty({
                            color: color,
                            outlineWidth: 0
                        })
                    }
                };
                let entity = new this.Cesium.Entity(options);
                markerDataSource.entities.add(entity);

                return {
                    id: entity.id,
                    options: options
                };
            },
            createPolygon(markerDataSource, positions, color) {
                let that = this;
                if (!this.Cesium.defined(color)) {
                    color = this.Cesium.Color.WHITE;
                }
                if (!this.Cesium.defined(positions)) {
                    throw new this.Cesium.DeveloperError("positions is required!");
                }
                if (positions.length < 3) {
                    throw new this.Cesium.DeveloperError("positions 的长度必须大于等于3");
                }
                // 准备参数
                let options = {
                    polygon: {
                        height: 0,
                        hierarchy: new this.Cesium.CallbackProperty(function () {
                            return new that.Cesium.PolygonHierarchy(positions);
                        }, false),
                        material: color.withAlpha(0.5),
                        outline: true,
                        outlineColor: color,
                        outlineWidth: 2
                    }
                };
                let entity = new this.Cesium.Entity(options);
                markerDataSource.entities.add(entity);

                return  entity.id;
            }
        }
    };
</script>
<style scoped>
    #cesiumContainer {
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>
